import InvoicesList from './List';
import Form from './Form';

export default {
  list: InvoicesList,
  edit: Form,
};
